import { NotificationType } from "../../types/types";

export const getAlertEnableOrUpdateInput = (
  alertType: NotificationType,
  phone: string
) => {
  return { DestinationType: alertType, DestinationAddress: phone };
};
